import React from 'react';
import Icon from '../../../components/AppIcon';

const TradeMetrics = ({ metrics }) => {
  const formatCurrency = (amount) => {
    return `₹${amount?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
  };

  const formatPercentage = (value) => {
    const sign = value >= 0 ? '+' : '';
    return `${sign}${value?.toFixed(2)}%`;
  };

  const getPercentageColor = (value) => {
    return value >= 0 ? 'text-success' : 'text-error';
  };

  const metricCards = [
    {
      title: 'Total Trades Today',
      value: metrics?.totalTrades?.toLocaleString('en-IN'),
      change: metrics?.tradesChange,
      icon: 'Activity',
      color: 'text-primary'
    },
    {
      title: 'Executed Trades',
      value: metrics?.executedTrades?.toLocaleString('en-IN'),
      change: metrics?.executedChange,
      icon: 'CheckCircle',
      color: 'text-success'
    },
    {
      title: 'Pending Orders',
      value: metrics?.pendingTrades?.toLocaleString('en-IN'),
      change: metrics?.pendingChange,
      icon: 'Clock',
      color: 'text-warning'
    },
    {
      title: 'Failed Trades',
      value: metrics?.failedTrades?.toLocaleString('en-IN'),
      change: metrics?.failedChange,
      icon: 'XCircle',
      color: 'text-error'
    },
    {
      title: 'Total Volume',
      value: formatCurrency(metrics?.totalVolume),
      change: metrics?.volumeChange,
      icon: 'TrendingUp',
      color: 'text-accent'
    },
    {
      title: 'Avg Execution Time',
      value: `${metrics?.avgExecutionTime}ms`,
      change: metrics?.executionTimeChange,
      icon: 'Zap',
      color: 'text-secondary'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
      {metricCards?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <Icon name={metric?.icon} size={20} className={metric?.color} />
            <div className={`text-xs font-medium ${getPercentageColor(metric?.change)}`}>
              {formatPercentage(metric?.change)}
            </div>
          </div>
          
          <div className="space-y-1">
            <div className="text-2xl font-bold text-foreground">{metric?.value}</div>
            <div className="text-xs text-muted-foreground">{metric?.title}</div>
          </div>

          {/* Mini trend indicator */}
          <div className="mt-3 flex items-center space-x-1">
            <Icon
              name={metric?.change >= 0 ? 'TrendingUp' : 'TrendingDown'}
              size={12}
              className={getPercentageColor(metric?.change)}
            />
            <span className="text-xs text-muted-foreground">vs yesterday</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TradeMetrics;